import { render, staticRenderFns } from "./addActive.vue?vue&type=template&id=365ab64a"
import script from "./addActive.vue?vue&type=script&lang=js"
export * from "./addActive.vue?vue&type=script&lang=js"
import style0 from "./addActive.vue?vue&type=style&index=0&id=365ab64a&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports